/*
 * Supscription form
 *
 */
 var applyPopup = true;

 var ctbSubmitSubscribe = function(email, nonce, source, wrap) {
     var error = '';

     // Validation
     if ( !email.length ) {
         error = CT.subcribeMsgEmpty;
     } else {
         var valid = /^\S+[@]{1}\S+\.+\S+$/.test(email);

         if ( !valid ) {
             error = CT.subcribeMsgNotValid;
         }
     }

     if ( error.length ) {
         wrap.find('.message').html(error);
         wrap.find('.message').addClass('text-danger');
         wrap.find('.message').show();

         return error;
     }

     jQuery.get(
         window.CT.ajaxurl,
         {
             action: 'ctb_subscribe',
             email: email,
             url: encodeURIComponent(window.location.href),
             nonce: nonce,
             source: source,
         },
         function( response ) {
             if ( parseInt(response.code) > 0 ) {
                 wrap.find('.message').html(response.message);
                 wrap.find('.message').addClass('text-danger');
                 wrap.find('.message').show();
             } else {
                 wrap.children().hide();

                 wrap.find('.message').html(CT.subcribeMsgSuccess);
                 wrap.find('.message').removeClass('text-danger');
                 wrap.find('.message').addClass('text-success');
                 wrap.find('.message').show();

                 localStorage.setItem( 'popup-applied', 1 );
             }
         },
         'json'
     );

     return error;
 };

(function($) {
    // Animation on focus/blur
    $('#ctb_subscription_email').focus( function() {
        $('.ctb_subscription_wrap .message').hide();
        $('.ctb_subscription_email_label').addClass('focused');
    });

    $('#ctb_subscription_email').blur( function() {
        if ( !$(this).val().length ) {
            $('.ctb_subscription_email_label').removeClass('focused');
        }
    });

    $('#ctb_subscription_email').change( function() {
        $('.ctb_subscription_wrap .message').hide();
    });

    if ( $('.exit-popup').length ) {
        // Check if we didn't show the popup before (1 week)
        var time = localStorage.getItem( 'exit-popup' ),
            applyPopup = true;

        if ( null !== time ) {
            time = Date.now() - time;
            time = Math.floor(time / 1000); // seconds
            time = Math.floor(time / 60); // minutes
            time = Math.floor(time / 60); // hours
            time = Math.floor(time / 24); // days

            applyPopup = time >= parseInt(CT.popupPeriod);
        }

        $(document).mouseleave( function() {
            if ( !applyPopup && 0 !== parseInt(CT.popupPeriod) ) {
                return;
            }

            if ( null !== localStorage.getItem( 'popup-applied' ) ) {
                return;
            }

            localStorage.setItem( 'exit-popup', Date.now() );
            applyPopup = false;

            $('.exit-popup').modal('show');
        });
    }

    // Subscribe btn (widget)
    $('.ctb_subscription_wrap .btn').click( function(e) {
        e.preventDefault();

        var error = ctbSubmitSubscribe(
            $('#ctb_subscription_email').val().trim(),
            $('#ctb_subscription_nonce').val(),
            'widget',
            $('.ctb_subscription_wrap')
         );
    });

    // Subscribe btn (popup)
    $('.exit-popup-subscription .ctb_subscription_submit').click( function(e) {
        e.preventDefault();

        var error = ctbSubmitSubscribe(
            $('.exit-popup-subscription .ctb_subscription_email').val().trim(),
            $('#ctb_subscription_nonce_popup').val(),
            'popup',
            $('.exit-popup-subscription')
         );
    });
})(jQuery);
